import React, { useState, useEffect } from "react";
import { Link } from 'react-router-dom'
import InfiniteScroll from "react-infinite-scroller";
import { Markup } from 'interweave';
import axios from "axios";
import { ReactSession } from 'react-client-session';
import {Helmet} from "react-helmet";

import Header from "../Header/Header";
import Sidebar from "../Sidebar/Sidebar";
import Footer from "../../Footer/Footer";
import Spinner from "../../Global/Spinner";
import EmptyContent from '../../Global/EmptyContent';

import '../Dashboard.css';
import classes from "./Activities.module.css";
import styles from '../Dashboard.module.css';

const licon = [];
licon["1"] = "fa-heart";
licon["2"] = "fa-share-nodes";
licon["3"] = "fa-circle-play";
licon["4"] = "fa-upload";
licon["5"] = "fa-rss";
licon["6"] = "fa-message";
licon["7"] = "fa-thumbs-up";
licon["8"] = "fa-camera";
licon["9"] = "fa-star";

const lback = [];
lback["1"] = lback["9"] = classes.bg_smooth;
lback["2"] = classes.bg_success;
lback["3"] = classes.bg_flat;
lback["4"] = lback["8"] = classes.bg_default;
lback["5"] = classes.bg_default;
lback["6"] = classes.bg_info;
lback["7"] = classes.bg_smooth;

function Activities() {
  const [activities, setActivities] = useState([]);
  const [count, setCount] = useState(0);
  const [hasMore, sethasMore] = useState(true);
  const [page, setpage] = useState(2);
  const [loading, setLoading] = useState(false);
  ReactSession.setStoreType("localStorage");

  const logged_user = ReactSession.get("logged_user");

  useEffect(() => {
    axios.post(`${process.env.REACT_APP_API_URL}/api/user/activities.php?page=1&limit=20`, {
      uid: logged_user
    }, {
      headers: {
        "Content-Type": "multipart/form-data",
      }
    })
      .then(res => {
        // console.log(res.data);
        if(res.data.message !== 'No Activities found') {
          setActivities(res.data);
          setCount(res.data[0].count || 0);
          res.data.length < 20 ? sethasMore(false) : sethasMore(true);
        }else {
          sethasMore(false);
        }

        setLoading(true);
      }).catch(err => {
        console.log(err);
      })
  }, [logged_user])

  const loadMore = () => {
    axios.post(`${process.env.REACT_APP_API_URL}/api/user/activities.php?page=${page}&limit=20`, {
      uid: logged_user
    }, {
      headers: {
        "Content-Type": "multipart/form-data",
      }
    })
      .then(res => {
        if(res.data.message !== 'No Activities found') {
          loading && hasMore && setActivities([...activities, ...res.data]);
          setpage(page + 1);
  
          res.data.length < 20 ? sethasMore(false) : sethasMore(true);
        }else {
          sethasMore(false);
        }
      }).catch(err => {
        console.log(err);
      })
  }

  return (
    <>
      <Helmet>
        <title>Activities</title>
      </Helmet>
      <div className="container_wrapper">
          <Header />
        <div className={`${styles.main} main`}>
          <Sidebar active="activities" />
          <div className={styles.main_content}>
            <div className={styles.content_body}>
              <div className={`${styles.title} mb-4`}>
                <h5><i className="fa-solid fa-film"></i> Activity on your media</h5>
              </div>
              <div className={styles.card}>
                { count > 0 ? <div className="card-body">
                  <div className={classes.act_count}>
                    <span className={`badge ${lback[6]}`}><i className="fa-solid fa-bell"></i> {count}</span>
                  </div>
                  <div className={classes.user_timeline}>
                    <div className={classes.activities}>
                      {
                        activities && activities.map && <InfiniteScroll
                          pageStart={0}
                          loadMore={loadMore}
                          hasMore={hasMore}
                          loader={<div className="loader my-4" key={0} align="center">{<Spinner />}</div>}
                          className='row'
                        >
                          {
                            activities.map((activity, index) => {
                              return (
                                <div className={classes.activity} key={index}>
                                  <div className={classes.timeline_top}>
                                    <div className={classes.timeline_time}>{activity.buzz.time_ago}</div>
                                    <i className={`fa-solid ${licon[activity.buzz.type]} ${classes.timeline_icon} ${lback[activity.buzz.type]}`}></i>
                                  </div>
                                  <div className={classes.timeline_content}>
                                    <p><Link to={`/profile/${activity.buzz.user_id}/${activity.buzz.nice_url}`}>{activity.buzz.name} </Link> <span className="text-muted">{activity.did.what}</span> <Link className="text-primary" to={activity.did.url} title={activity.did.title}><Markup content={activity.did.title} /></Link></p>
                                  </div>
                                </div>
                              )
                            })
                          }
                        </InfiniteScroll>
                      }
                      
                    </div>
                  </div>
                </div>
                : <EmptyContent />
                }
              </div>
            </div>
            <Footer />
          </div>
        </div>
      </div>
    </>
  );
}

export default Activities;